<template>
  <div class="test-container">
    <!-- 操作 -->
    <div style="margin-bottom:16px;overflow:hidden">
      <div style="float:left">
        <span class="title">人员列表</span>
      </div>
      <div style="float:right">
        <el-button type="primary" icon="el-icon-plus" class="addPerson" style="background-color:#fff" @click="addPerson">添加员工</el-button>
      </div>

    </div>
    <!-- 搜索 -->
    <div class="flex">
      <el-row>
        <el-col :span="21">
          <div class="grid-content bg-purple-dark">
              <el-form
              :inline="true"
              :model="search"
              label-width="100px"
            >
              <el-form-item
                label="员工工号"
                class="code"
                label-width="80px"
              >
                <el-input
                  v-model="search.code"
                  auto-complete="off"
                  placeholder="请输入员工工号"
                  class="w150"
                  width="180px"
                />
              </el-form-item>
              <el-form-item
                label="员工姓名"
                class="code"
              >
                <el-input
                  v-model="search.name"
                  auto-complete="off"
                  placeholder="请输入姓名"
                  width="180px"
                />
              </el-form-item>
              <el-form-item
                label="手机号码"
                class="code"
              >
                <el-input
                  v-model="search.telephone"
                  auto-complete="off"
                  placeholder="请输入联系方式"
                  width="180px"
                />
              </el-form-item>
    
              <el-form-item
                label="部门"
                class="searchItem"
              >
                <el-select
                  v-model="search.officeId"
                  filterable
                  width="180px"
                  placeholder="请选择部门"
                >
                  <el-option
                    v-for="item in departList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="角色"
                class="code"
       
                label-width="80px"
              >
                <el-tag
                  v-for="tag in roleList"
                  :key="tag.id"
                  v-model="search.roleIds"
                  :value="tag.id"
                  :class="isActive.indexOf(tag.id)!==-1?'Active':''"
                  @click="changeActive(tag.name,tag.id)"
                >
                  {{ tag.name }}
                </el-tag>
              </el-form-item>
           
            </el-form>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark" style="float: right">
              <el-button
              class="mr5"
              type="primary"
              size="medium"
              style="margin-left:10px"
              @click="query"
            >查询</el-button>
            <el-button
              class="mr5"
              size="medium"
              style="margin-left:10px"
              @click="reset"
            >重置</el-button>
          </div>
        </el-col>
        
      </el-row>
    </div>
    <!-- 表格 -->
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      @cell-mouse-enter="operateShow"
      @cell-mouse-leave="operateClose"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        fixed
        label="员工工号"
        min-width="100px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="员工姓名"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.name) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="手机号码"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.telephone) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="性别"
        min-width="100px"
      >
        <template slot-scope="scope">{{ scope.row.sex==1?"男":"女" }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="身份证号"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.card) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="户籍地址"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.censusArea) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="毕业院校"
        min-width="100px"
      >
        <template slot-scope="scope">{{ scope.row.graduatedSchool }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="专业"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.specialty) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="部门"
        min-width="100px"
      >
        <template slot-scope="scope">{{ departName(scope.row.officeId).val }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="关联角色"
        min-width="100px"
      >
        <template slot-scope="scope">{{ roleName(scope.row.roleIds) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="状态"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isEnable"
            :active-value="1"
            :inactive-value="0"
            
            @change="changeStatus(scope.row.id,scope.row.isEnable)"
          />
        </template>

      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        width="200px"
      >
        <template
          slot-scope="scope"
          class="icon"
        >
          <div class="icon">
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <i
                class="el-icon-change"
                style="margin-right:16px"
                @click="editInfo(scope.row.id)"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="重置密码"
              placement="top"
            >
              <i
                class="el-icon-update"
                style="margin-right:16px"
                @click="changePas(scope.row.name,scope.row.id)"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <i
                class="el-icon-dele"
                style="margin-rigth:16px"
                @click="deletePerson(scope.row.id,scope.row.name)"
              />
            </el-tooltip>

          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination
        :current-page="pageInfo.currentPage"
        :page-size="pageInfo.limit"
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.allCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 编辑人员 -->
    <div v-if="dialogVisibleEdit">
        <EditPerson
          :key="new Date().getTime()"
          :user-id="ids"
          :is-edit="isEdit"
          @returnResult="receiveData"
        />
    </div>
    <!-- 查看人员 -->
    <div v-if="dialogVisibleDetail">
    
        <PersonDetail
          :key="new Date().getTime()"
          :person-id="userId"
          @returnResult="receiveData"
        />
     
    </div>
  </div>
</template>
<script>
import {
  personList,
  getLocalDictionary,
  resetPwd,
  open,
  userInfo,
  roleList,
  getDepartList,
  deleteUser,
  quit
} from '@/api/system'
import { orgTrans, emptyTrans, sortDataList,roleTrans } from '@/api/dataTrans.js'
import {
  removeStroage
} from '@/utils/auth'
import EditPerson from './components/EditPerson'
import PersonDetail from './components/PersonDetail'
import Settings from '../../settings'
const {
  workBenchDomain
} = Settings
workBenchDomain
import md5 from 'js-md5'
export default {
  components: {
    EditPerson,
    PersonDetail
  },
  data() {
    return {
      isClick:false,
      isEdit: false,
      list: [],
      listLoading: false,
      tableKey: 0,
      dialogVisibleReceive: false,
      isActive: '',
      pageInfo: {
        limit: 10,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      search: {
        name: '',
        telephone: '',
        officeId: '',
        code: '',
        roleIds: ''
      },
      createTime: '',
      clientList: [],
      open: true,
      dialogVisibleEdit: false,
      ids: null,
      dialogVisibleDetail: false,
      userId: null,
      id: null,
      roleList: [],
      departList: [],
     arr:[]
    }
  },
  watch: {
    createTime: {
      deep: true,
      handler: function(val, old) {
        this.search.startTime = this.getDate(val[0])
        this.search.endTime = this.getDate(val[1])
      }
    }
  },
  mounted() {
    getDepartList().then(res => {
      if (res && res.code == 0) {
        this.departList = res.data
        console.log(this.departList)
      }
    })
    this.getPersonList()
    this.getRoleList()
  },
  methods: {
    getRoleList() {
      roleList({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        if (res && res.code == 0) {
          this.roleList = res.data.items
        }
      })
    },
    roleName(_val) {
      return roleTrans(_val, this.roleList)
    },
    departName(_val) {
      return orgTrans(_val, this.departList)
    },
    getPersonList() {
      const pramaList = this.search
      personList({
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit,
        ...pramaList
      }).then(res => {
        this.list = sortDataList(res.data.items, this.pageInfo.currentPage)
        this.list = res.data.items
        this.pageInfo.allCount = res.data.total
      })
    },
    addPerson() {
      this.isEdit=false
      this.dialogVisibleEdit = true
    },
    emptyDeal(_val) {
      return emptyTrans(_val)
    },

    // 显示操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[11].children[0].children[0].style.display = 'block'
    },
    operateClose() {
      event.path[1].cells[11].children[0].children[0].style.display = 'none'
    },
    query() {
      this.pageInfo.pageNum = 1
      this.getPersonList()
    },
    reset() {
      this.isActive = ''
      this.search.name = ''
      this.search.telephone = ''
      this.search.officeId = ''
      this.search.code = ''
      this.search.roleIds = ''
      this.getPersonList()
      this.arr=[]
      console.log(this.arr)
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.getPersonList()
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getPersonList()
    },
    changePas(name, id) {
      this.$confirm('您确定要重置' + name + '的密码吗？', '确认重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var str=''
        for(var i=0;i<4;i++){
          str+=Math.floor(Math.random()*10)
          var num=Math.floor(Math.random()*25)
          str+=String.fromCharCode(97+num)
        }
          const pass = md5(str)
          this.$confirm(name + '的密码已重置为:' + str, '重置成功', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
              resetPwd({
                ids: id,
                pwd: pass
              }).then(res => {
                
              })
            }).catch(() => {})
        }).catch(() => {})
    },
    editInfo(data) {
      this.ids = data
      this.isEdit = true
      this.dialogVisibleEdit = true
    },
    receiveData() {
      this.dialogVisibleEdit = false
      this.dialogVisibleDetail = false
      this.getPersonList()
    },
    changeStatus(id, able) {
      const _this=this
      // _this.returnMsg()
      open({
        ids: id,
        isEnable: able
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success('操作成功')
          this.getPersonList()
        } else {
          this.getPersonList() 
        }
      })
    },
    detail(row) {
      this.userId = row.id
      this.dialogVisibleDetail = true
    },
    deletePerson(data, name) {
      this.$confirm('确定删除' + name + '吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteUser({
          ids: data
        }).then(res => {
          if (res && res.code == 1) {
            this.getPersonList()
          }
        })
      })
        .catch(() => {})
    },
    changeActive(data, id) {
         const ids=id+""
       const str=this.arr.toString()
       if(str.indexOf(ids)==-1){
         this.arr.push(ids)
       }else if(str.indexOf(ids)!=-1){
         for(var i=0;i<this.arr.length;i++){
           if(this.arr[i]==ids){
             this.arr.splice(i,1)
           }
         }
       }
       console.log(this.arr)
       console.log(this.search.roleIds)
        this.search.roleIds=this.arr.toString()
      this.isActive = this.search.roleIds
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-button--primary{
    border-color: #fff
  }
.operate {
  float: right;
  height: 24px;
}
.title {
  text-align: left;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.el-table {
  margin-top: 16px;
}
body .app-wrapper-new-style .test-container {
  padding: 16px 24px 100px 24px;
}
[class^="el-icon-"] {
  font-size: 16px;
  margin-left: 18px;
}
[class^="el-icon-"]:hover {
  color: #ffa940;
}
.mt10 {
  margin-top: 24px !important;
  float: right;
}
.icon {
  display: none;
}
.el-form-item {
  margin-bottom: 0;
  margin-top: 8px;
}
[class*=" el-icon-"],
[class^="el-icon-"] {
  margin-right: 16px;
  font-size: 16px;
}
// .el-button.is-round {
//   padding: 5px 20px;
//   margin-right: 8px;
// }
.addPerson {
  color: #ffa940;
}
.addPerson:hover{
  color:rgba(255,169,64,0.75);
}
/* /deep/.el-dialog {
  height: 600px;
  overflow-y: scroll;
} */
.el-tag {
  margin-right: 8px;
  padding: 0px 8px;
  height:22px;
  line-height:22px;
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid #D9D9D9;
  background-color: #fff;
  border-radius: 20px;
}
.Active{
 background-color: rgba(255,169,64,0.05);
   border:1px solid #FFA940;
     color: #FFA940;
}
.flex{
  margin-left:-11px;
}
</style>
